import { StateChangesType } from '../../../../../types/rest/analyticsTypes';

export const SELECT_STATE_CHANGES_VIEW_TRIGGER = 'SELECT_STATE_CHANGES_VIEW_TRIGGER';
export const SET_STATE_CHANGES_ACTIVE_PAGE = 'SET_STATE_CHANGES_ACTIVE_PAGE';
export const SET_STATE_CHANGES_PAGE_SIZE = 'SET_STATE_CHANGES_PAGE_SIZE';
export const SET_STATE_CHANGES_SEARCH_KEYWORD = 'SET_STATE_CHANGES_SEARCH_KEYWORD';

export type SelectStateChangesViewTrigger = {
  type: typeof SELECT_STATE_CHANGES_VIEW_TRIGGER;
  payload: StateChangesType | null;
};
export type ChangeStateChangesActivePage = {
  type: typeof SET_STATE_CHANGES_ACTIVE_PAGE;
  payload: number;
};
export type ChangeStateChangesPageSize = {
  type: typeof SET_STATE_CHANGES_PAGE_SIZE;
  payload: number;
};
export type SetStateChangesSearchKeyword = {
  type: typeof SET_STATE_CHANGES_SEARCH_KEYWORD;
  payload: string;
};
export type StateChangesActionTypes =
  | SelectStateChangesViewTrigger
  | ChangeStateChangesActivePage
  | ChangeStateChangesPageSize
  | SetStateChangesSearchKeyword;
